import { soundManager } from "soundmanager2";

import qrWav from "../sounds/qr01.wav";
import sorryCodeWav from "../sounds/sorrycode02.wav";
import sorryErrorWav from "../sounds/sorryerror03.wav";
import sorryNoAccessWav from "../sounds/sorrynoaccess02.wav";
import sorryNoAnswerWav from "../sounds/sorrynoanswer02.wav";
import throttleWav from "../sounds/throttle03.wav";
import welcomeWav from "../sounds/welcome04.wav";
import ringWav from "../sounds/ring.wav";
import errorWav from "../sounds/error.wav";
import successWav from "../sounds/success.wav";
import gateOpenWav from "../sounds/gateopen.wav";
import { Sound, Sounds } from "src/common/types";

const sounds: Sounds = {};
let ring: soundmanager.SMSound | undefined;

soundManager.setup({
  onready: () => {
    sounds[Sound.Error] = soundManager.createSound({
      url: errorWav,
      autoLoad: true,
      multiShot: false,
    });

    sounds[Sound.Success] = soundManager.createSound({
      url: successWav,
      autoLoad: true,
      multiShot: false,
    });

    sounds[Sound.Qr] = soundManager.createSound({
      url: qrWav,
      autoLoad: true,
      multiShot: false,
    });

    sounds[Sound.SorryCode] = soundManager.createSound({
      url: sorryCodeWav,
      autoLoad: true,
      multiShot: false,
    });

    sounds[Sound.SorryError] = soundManager.createSound({
      url: sorryErrorWav,
      autoLoad: true,
      multiShot: false,
    });

    sounds[Sound.SorryNoAccess] = soundManager.createSound({
      url: sorryNoAccessWav,
      autoLoad: true,
      multiShot: false,
    });

    sounds[Sound.SorryNoAnswer] = soundManager.createSound({
      url: sorryNoAnswerWav,
      autoLoad: true,
      multiShot: false,
    });

    sounds[Sound.Throttle] = soundManager.createSound({
      url: throttleWav,
      autoLoad: true,
      multiShot: false,
    });

    sounds[Sound.Ring] = soundManager.createSound({
      url: ringWav,
      autoLoad: true,
      multiShot: false,
    });

    sounds[Sound.Welcome] = soundManager.createSound({
      url: welcomeWav,
      autoLoad: true,
      multiShot: false,
    });

    sounds[Sound.GateOpen] = soundManager.createSound({
      url: gateOpenWav,
      autoLoad: true,
      multiShot: false,
    });
  },
});

export const playSound = (sound: string, options = {}) => {
  soundManager.stopAll();

  if (sounds[sound]) {
    return soundManager.play(sounds[sound].id, options);
  } else {
    console.error(`Sound ${sound} not loaded yet`);
  }
};

export const stopSound = () => {
  soundManager.stopAll();
};

export const startRinging = () => {
  stopRinging();
  ring = playSound(Sound.Ring, { loops: Infinity });
};

export const stopRinging = () => {
  if (ring) {
    ring.stop();
  }
};
